/**
 * Bahamian dollar.
 */
export var BSD = {
  code: 'BSD',
  base: 10,
  exponent: 2
};